import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import HeaderMenu from "../../components/ui-elements/header";
import { Utils } from "../../resources/util";
import { useStyles } from "./styles";
import { useMediaQuery } from "react-responsive";
const SelectPackage = (props) => {
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const amount = params.get("amount");
  const postcode = params.get("postcode");
  const classes = useStyles();
  const [packageData, setPackageData] = useState([]);
  const [rowData, setRowData] = useState(undefined);
  const [originalRecommendation, setOriginalRecommendation] =
    useState(undefined);
  const rowKeys = {
    currentQuarterlyBill: "Your current quarterly bill",
    systemSize: "System size",
    estimatedYearlySavings: "Estimated yearly savings",
    fortnightlyPayments: "Fortnightly payments*"
  };
  const recommnededTagIcon = require("../../resources/images/recommended.png");
  const recommnededTag = require("../../resources/images/recommended1.png");
  const [open, setOpen] = React.useState(false);
  const userDetailFormInitial = {
    fullName: "",
    mobile: "",
  };
  const [userDetailForm, setUserDetailForm] = useState(userDetailFormInitial);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [showFormError, setShowFormError] = useState(false);
  const [formErrorMessage, setformErrorMessage] = useState("");

  const handleClickOpen = () => {
    setShowFormError(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // Fetch packages
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${Utils.getBaseApiUrl()}/packages`, {
          params: { currentQuarterlyBill: amount },
        });
        if (isMobile) {
          const recPkg = response.data.find((o) => o.recommendedPackage);
          const sortedPkgList = response.data.filter(
            (o) => !o.recommendedPackage
          );
          sortedPkgList.unshift(recPkg);
          setPackageData(sortedPkgList);
        } else {
          setPackageData(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    if (packageData.length && !originalRecommendation) {
      setOriginalRecommendation(packageData.find((o) => o.recommendedPackage));
    }
  }, [packageData]);

  // Construct row data
  useEffect(() => {
    if (packageData) {
      const obj = {};
      Object.keys(rowKeys).forEach((k) => {
        obj[k] = packageData.map((item) => {
          return {
            pkg: item.packageName,
            val: item[k],
            recommendedPackage: item.recommendedPackage,
            pkgId: item.id,
          };
        });
      });
      if (props.location.state.showFortnightlyPayments !== 'true') {
        delete obj.fortnightlyPayments
      }
      setRowData(obj);
    }
  }, [packageData]);

  // Package change handler
  const onPackageChange = (newPackageId) => {
    const updatedPackageData = [...packageData];

    packageData.forEach((pkg, i) => {
      if (pkg.recommendedPackage) {
        if (pkg.id === newPackageId) {
          // Same pckage selected
          return;
        }
        // Remove last known recommended package
        updatedPackageData[i].recommendedPackage = false;
      }
      if (pkg.id === newPackageId) {
        // Set new recommendation
        updatedPackageData[i].recommendedPackage = true;
      }
    });

    setPackageData(updatedPackageData);
  };

  // "Book free on-site qoute..." button click handler
  const redirectToQuotationForm = () => {
    const obj = packageData.find((o) => o.recommendedPackage);
    const url = `https://www.nrgsolar.com.au/quotation?postcode=${postcode}&qtry_bills=${amount}&system_size=${obj.systemSize}&fn_payment_budget=${obj.fortnightlyPayments}`;
    window.open(url);
  };

  const orderNow = () => {
    const obj = packageData.find((o) => o.recommendedPackage);
    const url = `https://www.nrgsolar.com.au/ordernow?postcode=${postcode}&qtry_bills=${amount}&system_size=${obj.systemSize}&fn_payment_budget=${obj.fortnightlyPayments}`;
    window.open(url);
  };

  const handleInputChange = (key, value) => {
    setUserDetailForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    if (userDetailForm.fullName && userDetailForm.mobile) {
      axios
        .post(`${Utils.getBaseApiUrl()}/mail/consumer-details`, userDetailForm)
        .then((response) => {
          setIsEmailSent(true);
          setShowFormError(false);
          handleClose();
          setTimeout(() => {
            setIsEmailSent(false);
          }, 3000);
        })
        .catch((error) => {
          setformErrorMessage("Something went wrong. Please try again later");
          setShowFormError(true);
        });
    } else {
      setformErrorMessage("Please enter both full name and mobile number to continue");
      setShowFormError(true);
    }
  };

  return (
    <Grid className={classes.root}>
      <HeaderMenu noFnPayBgt="true" />

      {packageData.length ? (
        <div>
          <Grid item xs={12}>
            <Typography variant="h6" className={classes.detailTitle}>
              Sounds like your average quarterly bill is $
              {Utils.formatCurrency(amount)}
            </Typography>
            <Typography variant="h6" className={classes.detailTitle2}>
              The NRG Premium Solar Package that would best suit you is
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {!isMobile ? (
              <div className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  size="medium"
                  align="center"
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        className={classes.tableHead2}
                      ></TableCell>
                      {packageData &&
                        packageData.map((row, i) => (
                          <TableCell
                            key={i}
                            align="center"
                            className={`${
                              row.recommendedPackage && classes.selectedThCell
                            } ${classes.tableHead}`}
                            onClick={() => onPackageChange(row.id)}
                          >
                            {originalRecommendation &&
                              originalRecommendation.id === row.id && (
                                <div className={classes.recommendedPackage}>
                                  <div className={classes.recommnededTagIcon}>
                                    <img
                                      src={recommnededTag}
                                      alt="Recommended"
                                    />
                                  </div>
                                  <div>Recommended</div>
                                </div>
                              )}
                            {row.packageName}
                          </TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowData &&
                      Object.keys(rowData).map((row, i, rowArr) => (
                        <TableRow key={i}>
                          <TableCell
                            align="center"
                            className={classes.tableHead3}
                          >
                            {rowKeys[row]}
                          </TableCell>
                          {rowData[row].map((cell, idx) => (
                            <TableCell
                              key={idx}
                              align="center"
                              className={`${
                                cell.recommendedPackage &&
                                classes.selectedTdCell
                              } ${
                                cell.recommendedPackage &&
                                i === rowArr.length - 1 &&
                                classes.lastSelectedTdCell
                              }`}
                              onClick={() => onPackageChange(cell.pkgId)}
                            >
                              {`${row !== "systemSize" ? "$" : ""}${
                                isNaN(cell.val)
                                  ? cell.val
                                  : Math.floor(cell.val)
                              }`}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <div className={classes.mobileViewContainer}>
                <div className={classes.recommendedPackageMobileView}>
                  <img
                    style={{ marginRight: "3px" }}
                    src={recommnededTagIcon}
                    alt="Recommended"
                  />
                  Recommended
                </div>
                {packageData &&
                  packageData.map((nrgPackage, i) => (
                    <Card
                      className={`${
                        nrgPackage.recommendedPackage &&
                        classes.selectedMobileCard
                      } ${classes.mobileViewCard}`}
                      elevation={10}
                      key={i}
                    >
                      <Grid
                        item
                        xs={12}
                        onClick={() => onPackageChange(nrgPackage.id)}
                      >
                        <Grid
                          key={i}
                          container
                          justifyContent="center"
                          spacing={1}
                        >
                          <Grid xs={6} item></Grid>
                          <Grid
                            xs={6}
                            container
                            justifyContent="center"
                            item
                            className={`${classes.mobileViewCardCell} ${classes.mobileViewCardPkg}`}
                          >
                            {nrgPackage.packageName}
                          </Grid>
                        </Grid>
                        {rowData &&
                          Object.keys(rowData).map((row, i) => (
                            <Grid
                              key={i}
                              container
                              justifyContent="center"
                              spacing={1}
                            >
                              <Grid
                                xs={6}
                                className={classes.mobileViewCardCellHeader}
                                item
                              >
                                <div>{rowKeys[row]}</div>
                              </Grid>
                              <Grid
                                xs={6}
                                container
                                alignContent="center"
                                justifyContent="center"
                                item
                                className={classes.mobileViewCardCell}
                              >
                                <div>
                                  {`${row !== "systemSize" ? "$" : ""}${
                                    nrgPackage[row]
                                  }`}
                                </div>
                              </Grid>
                            </Grid>
                          ))}
                      </Grid>
                    </Card>
                  ))}
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            className={`${isMobile && classes.continueButtonContainer}`}
          >
            <Button
              variant="contained"
              color="primary"
              // onClick={redirectToSystemDetails}
              onClick={handleClickOpen}
              className={classes.continueButton}
              size="large"
            >
              Send me information about this system
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={redirectToQuotationForm}
              className={classes.continueButton}
              size="large"
            >
              Book free on-site quote
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={orderNow}
              className={classes.continueButton}
              size="large"
            >
              Order Now
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            className={`${isMobile && classes.continueButtonContainer}`}
          >
            <Typography variant="h6" className={classes.bottomTitle}>
              What is the best way to pay for solar: cash or finance?
            </Typography>
            <Typography variant="subtitle1" className={classes.bottomText}>
              Some customers pay with cash and others with credit or finance.
              The choice comes down to your preference. Using finance can be an
              excellent way to get into solar sooner or to keep your cash
              savings in the bank. Request a{" "}
              <span
                className={classes.textWithLink}
                onClick={redirectToQuotationForm}
              >
                free quote
              </span>{" "}
              and we will talk you through the best payment option for you.
            </Typography>
          </Grid>
          {isEmailSent && (
            <div className={classes.successMessage}>
              <div className={classes.successMessageTitle}>Your information has been submitted successfully </div>
            </div>
          )}
        </div>
      ) : (
        <div className={classes.loader}>
          <Loader type="Circles" color="#FB7906" height={80} width={80} />
        </div>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: "#fff",
            boxShadow: "none",
          },
        }}
      >
        <DialogTitle className={classes.popupTitle}>
          Send me more information about this system
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.popupText}>
            Please enter your full name and mobile number below
          </DialogContentText>
          <TextField
            required
            margin="dense"
            id="fullName"
            placeholder="Full Name"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => handleInputChange("fullName", e.target.value)}
            className={classes.popupInput}
          />
          <TextField
            required
            margin="dense"
            id="name"
            placeholder="Mobile"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => handleInputChange("mobile", e.target.value)}
            className={classes.popupInput}
          />
          {showFormError && (
            <div className={classes.formError}> {formErrorMessage}</div>
          )}
        </DialogContent>
        <DialogActions>
          <Button className={classes.popupBtnSec} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            className={classes.popupBtnPrimary}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default SelectPackage;
